import React, { useEffect, useState } from 'react'
import "react-data-table-component-extensions/dist/index.css";
import '../../modalright.css'
import '../../popup.css'
import axios from 'axios';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'font-awesome/css/font-awesome.min.css';

const localizer = momentLocalizer(moment); // Set up localizer
export default function Plan() {
    const API_URL = process.env.REACT_APP_API_URL;

    const [events, setEvents] = useState([]); // Array to hold events (orders)
    const [date, setDate] = useState(new Date());



    useEffect(() => {
        // Set the orders for September 25, 2024
        const ordersDate = new Date(2024, 9, 25); // Months are 0-indexed in JavaScript
        // const eventsData = [
        //     {
        //         title: '10 Orders',
        //         start: new Date(2024, 9, 2), // September 25, 2024
        //         end: new Date(2024, 9, 2),
        //         allDay: true,
        //         color: '#138127',
        //     },
        //     {
        //         title: 'Sharjah - 6 Orders',
        //         location: 'Sharjah',
        //         orderCount: 6,
        //         start: new Date(2024, 9, 2), // Same date (September 2, 2024)
        //         end: new Date(2024, 9, 2),
        //         allDay: true,
        //         color: '#edbc2b',
        //     },
        //     {
        //         title: '4 Orders',
        //         start: new Date(2024, 9, 5), // September 26, 2024
        //         end: new Date(2024, 9, 5),
        //         allDay: true,
        //         color: '#edbc2b',
        //     },
        //     {
        //         title: '6 Orders',
        //         start: new Date(2024, 9, 6), // September 27, 2024
        //         end: new Date(2024, 9, 6),
        //         allDay: true,
        //         color: '#2ba5ed',
        //     },
        //     {
        //         title: '5 Orders',
        //         start: new Date(2024, 9, 8), // September 25, 2024
        //         end: new Date(2024, 9, 8),
        //         allDay: true,
        //         color: '#138127',
        //     },
        //     {
        //         title: '16 Orders',
        //         start: new Date(2024, 9, 9), // September 25, 2024
        //         end: new Date(2024, 9, 9),
        //         allDay: true,
        //         color: '#138127',
        //     },
        // ];
        // setEvents(eventsData); // Set the events to display
    }, []);

    const handleSelect = (event) => {
        console.log('Selected event:', event);
    };


    const handleViewClick = (event) => {
        // Implement logic to handle viewing details
        console.log(`Viewing details for: ${event.title}`);
        window.location.href = 'view';
        // You can navigate to a detailed view here
    };
    const EventComponent = ({ event }) => {
        return (
            <div style={{ padding: '5px', textAlign: 'center', fontSize: '12px' }}
                onClick={() => handleEventClick(event)}>
                <div>{event.location ? `${event.location} - ${event.orderCount} Orders` : event.title}</div>
            </div>
        );
    };

    const handleEventClick = (event) => {
        const selectedDate = event.start.toISOString().split('T')[0];  // Get date in YYYY-MM-DD format
        const selectedEmirate = event.location;    // Access emirate directly from the event
        sessionStorage.setItem('selectedDate', selectedDate);  // Store selected date in sessionStorage
        sessionStorage.setItem('selectedEmirate', selectedEmirate);    // Store selected emirate in sessionStorage
        console.log(`Selected Date: ${selectedDate}, Emirate: ${selectedEmirate}`);
        window.location.href = '/orders/view'
    };

    const fetchOrders = async (assignedDate) => {
        try {
            const response = await axios.get(
                `${API_URL}shypvdriverapp/jobs/getOrdersByDate?assignedDate=${assignedDate}`
            );

            if (response.data.success) {
                // Process the response data
                const orders = response.data.data.orders;
                const eventsData = orders.map((order, index) => ({
                    title: `${order.emirate.toUpperCase()} - ${order.count} Orders`,
                    location: order.emirate.toUpperCase(),
                    orderCount: order.count,
                    start: new Date(order.date),  // Use the assignedDate as the date
                    end: new Date(order.date),    // Same date for start and end
                    allDay: true,
                    color: '#138127', // You can customize the color as needed
                    route_id: `ROUTE${index + 1}`, // Unique route ID for each entry
                }));
                setEvents(eventsData); // Update the events state
            } else {
                console.error("Error fetching orders:", response.data.errors);
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };

    const [currentMonth, setCurrentMonth] = useState(moment().month() + 1);

    useEffect(() => {
        // Example static date or you can use dynamic date
        fetchOrders(currentMonth);  // Call the function to fetch orders
    }, []);  // Empty dependency array means it runs once on mount

    const handleNavigate = (date) => {
        const month = moment(date).month() + 1; // moment months are zero-indexed, so we add 1
        setCurrentMonth(month); // Update the current month
        fetchOrders(month); // Fetch orders for the selected month
    };
    return (
        <div className="calendar-container">
            <h1>Order Calendar</h1>
            <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500 }}
                components={{
                    event: (props) => <EventComponent {...props} onEventClick={handleEventClick} />, // Pass onClick handler
                }}
                eventPropGetter={(event) => {
                    const backgroundColor = event.color;
                    return { style: { backgroundColor } };
                }}
                onNavigate={handleNavigate}
            />

        </div>
    )
}
